import { call } from 'redux-saga/effects';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';

export function* confirmEmailOnEnterSaga(client, nextState) {
  if (__SERVER__ && !__TEST__) {
    return;
  }

  let cookieValue = 'update_email_failure';
  try {
    const result = yield call(client.users.confirmEmailToken, nextState.params.key);
    cookieValue = result.email;
  } catch (err) {
    /* noop */
  }

  yield call(writeLocalStorage, 'cpChangeEmail', cookieValue);

  yield call(gtmSafeRedirect, '/settings/account');
}
